<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{user.id != null && user.id.length > 0 ? "Edit User" : "Add User"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveUser()">
    <div mat-dialog-content class="example-container">
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Username </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="50" placeholder="Username"
                            [formControl]="username" name="username" [(ngModel)]="user.username" />
                    <mat-error *ngIf="username.invalid">Username is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10" *ngIf="isPasswordVisible">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Password </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="password" maxlength="50" placeholder="Password"
                            [formControl]="password" name="password" [(ngModel)]="user.password" />
                    <mat-error *ngIf="password.invalid">Password is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">First Name </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="100" placeholder="First Name"
                            [formControl]="firstName" name="firstName" [(ngModel)]="user.firstName" />
                    <mat-error *ngIf="firstName.invalid">First Name is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Last Name </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="100" placeholder="Last Name"
                            [formControl]="lastName" name="lastName" [(ngModel)]="user.lastName" />
                    <mat-error *ngIf="lastName.invalid">Last Name is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Email </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="100" placeholder="Email"
                            [formControl]="email" name="email" [(ngModel)]="user.email" />
                    <mat-error *ngIf="email.invalid">Email is required</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center pt-3 pb-4 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" type="submit" class="oms-btn me-3">Save </button>&nbsp;&nbsp;
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="oms-btn-primary">Cancel </button>
            </div>
        </div>
    </div>
</form>
